<script setup>
import { reactive } from 'vue'

const emit = defineEmits(['filter', 'reset'])

// Estado local de los filtros
const filters = reactive({
  search: '',
  delegation_id: '28',
  sepa_status: '',
  lesson_status: '',
  enabled: true,
  /* alert: '' */
})

const handleSearch = () => {
  emit('filter', { ...filters })
}

const handleReset = () => {
  filters.search = ''
  filters.delegation_id = ''
  filters.sepa_status = ''
  filters.lesson_status = ''
  filters.enabled = ''
  /* filters.alert = '' */
  emit('reset')
}
</script>

<template>
  <div class="d-flex flex-column gap-3 mb-4">
    <div class="d-flex justify-content-between align-items-center">
      <h2 class="h4 mb-0 fw-bold text-dark">Listado de Expendedurías</h2>
      <button class="btn btn-sm btn-outline-secondary" @click="handleReset">
        Limpiar Filtros
      </button>
    </div>

    <div class="row g-2">
      <!-- Búsqueda por Texto -->
      <div class="col-12 col-md-4">
        <input 
          v-model="filters.search" 
          @keyup.enter="handleSearch"
          type="text" 
          class="form-control form-control-sm" 
          placeholder="Buscar por Nombre, ID o Ciudad..." 
        />
      </div>

      <!-- Filtro por delegación -->
      <div class="col-6 col-md-3">
        <select class="form-select form-select-sm" v-model="filters.delegation_id" @change="handleSearch">
          <option value="">-- Delegación --</option>
          <option value="28">ITG TABACO</option>
          <option value="19">Consuserco</option>
          <option value="2">Consuserco Resto</option>
          <option value="13">Delegación Cloud Madrid</option>
          <option value="15">Delegación SGRT</option>
          <option value="22">Portugal SDT</option>
          <option value="24">Delegación BAT</option>
          <option value="25">Delegación Imperial BluBar</option>
        </select>
      </div>

      <!-- Filtro Estado SEPA -->
      <div class="col-6 col-md-2">
        <select class="form-select form-select-sm" v-model="filters.sepa_status" @change="handleSearch">
          <option value="">-- SEPA --</option>
          <option value="PENDING">Pendiente</option>
          <option value="SIGNED">Firmado</option>
          <option value="CANCELED">Cancelado</option>
        </select>
      </div>

      <!-- Filtro Estado Formación -->
      <div class="col-6 col-md-3">
        <select class="form-select form-select-sm" v-model="filters.lesson_status" @change="handleSearch">
          <option value="">-- Formación --</option>
          <option value="PENDING">Pendiente</option>
          <option value="SCHEDULED">Agendado</option>
          <option value="COMPLETED">Completado</option>
          <option value="USER_NOT_DISPOSED">Usuario no disp.</option>
        </select>
      </div>

      <!-- Filtro para habilitados y deshabilitados -->
      <div class="col-6 col-md-2">
        <select class="form-select form-select-sm" v-model="filters.enabled" @change="handleSearch">
          <option value="">-- Estado --</option>
          <!-- Usamos :value para pasar booleanos reales en JS -->
          <option :value="true">Habilitado</option>
          <option :value="false">Deshabilitado</option>
        </select>
      </div>

      <!-- Filtro por Alertas -->
      <!-- <div class="col-12 col-md-3">
        <select class="form-select form-select-sm" v-model="filters.alert" @change="handleSearch">
          <option value="">-- Todas las Alertas --</option>
          <option value="CRITICAL">🚨 >1 mes (Exigir SEPA)</option>
          <option value="WARNING">⚠️ >20 días sin instalar</option>
          <option value="OK">✓ En Regla</option>
        </select>
      </div> -->
    </div>
  </div>
</template>